import type {OverlayOption} from '@stripe-internal/embedded-theming';
import {CONNECT_ELEMENTS_OVERLAYS_DEFAULT} from '@stripe-internal/embedded-theming';
import React from 'react';

export const OverlayOptionContext = React.createContext<
  OverlayOption | undefined
>(undefined);
OverlayOptionContext.displayName = 'OverlayOptionContext';

export const useOverlayOption = (): OverlayOption =>
  React.useContext(OverlayOptionContext) || CONNECT_ELEMENTS_OVERLAYS_DEFAULT;
